<template>
    <div class="relative">
        <input type="text"
               v-model="currentNumber"
               class="input"
               id="vat_number"
               name="vat_number"
               autocomplete="vat_number"
               :placeholder="label('shop.account.vat_number')"
               @keyup="keyupHandling"
        />
        <i class="fa fa-check valid" v-if="valid === true"></i>
        <i class="fa fa-times invalid" v-else-if="valid === false"></i>
    </div>
</template>

<script>
import {debounce} from "lodash";
import translations from "../mixins/translations";
import {EventBus} from "../../events";

const CancelToken = require('axios').CancelToken;
let cancelSource;

export default {
    name: "ValidateVatNumber",
    mixins: [translations],
    props: {
        number: {
            required: false,
            type: String,
            default: '',
        },
        cartId: {
            required: false,
            type: String,
        }
    },
    data() {
        return {
            currentNumber: '',
            valid: null,
        }
    },
    methods: {
        keyupHandling(event) {
            if (this.currentNumber.length >= 8 || this.valid === true) {
                this.validateVatNumber();
            }
        },
        validateVatNumber: debounce(function (country = '') {
            cancelSource && cancelSource.cancel('Request cancelled');
            cancelSource = CancelToken.source();

            let vatCountry = '';
            if(country !== ''){
                vatCountry = country;
            }
            axios.post(`/api/site/cart/validate-vat-number/`, {
                vat_number: this.currentNumber,
                cart_id: this.cartId,
                country: vatCountry,
                _method: 'PUT',
            }, {
                cancelToken: cancelSource.token
            })
                .then(response => {
                    this.valid = response.data.valid;
                    this.currentNumber = this.currentNumber.replaceAll(' ', '')
                    this.$store.dispatch('cart/loadCart');
                    // this.$emit('country', this.currentNumber.substr(0, 2));
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        // We cancelled this request...
                    } else {
                        this.valid = false;
                        // handle error
                    }
                }).finally(() => {
                this.isLoading = false;
            });
        }, 300),
    },
    watch: {
        currentNumber(newValue) {
          if (newValue === '') {
              this.$emit('emptied');
          }
        },
        valid(newValue, oldValue) {
            if (newValue === true) {
                this.$emit('valid');
            } else if (newValue === false) {
                this.$emit('invalid');
            }
        }
    },
    mounted() {
        this.currentNumber = this.number;
        if(this.currentNumber !== ""){
            this.validateVatNumber();
        }
        let vue = this;
        EventBus.$on('updatedCountry', function(country){
            if(vue.currentNumber !== ""){
                vue.validateVatNumber(country);
            }
        });
    }
}
</script>

<style scoped>
.valid, .invalid {
    position: absolute;
    right: 0;
    padding: 10px;
    top: 2px;
}

.valid {
    color: rgb(50, 170, 112);
}

.invalid {
    color: rgb(225, 31, 29);
}
</style>
